import { createActions, createState, createReducer } from 'reduxsauce-crud'
import {clone, findIndex, propEq} from "ramda";
import activityInProgressWarning from "../../Containers/StudentProfile/ActivityInProgressWarning";

const d = { deep: true }

export const ActivityRedux = createActions(
  {
    postActivityRequest: ['checkinId', 'data'],
    postActivitySuccess: ['data'],
    postActivityFailure: ['errors'],
    getPhotoCatalogueRequest: [],
    getPhotoCatalogueSuccess: ['data'],
    getPhotoCatalogueFailure: ['errors'],
    editCheckoutRequest: ['checkout_id','checkout_time'],
    editCheckoutSuccess: ['data'],
    editCheckoutFailure: ['errors'],
    postGroupActivityRequest: ['data'],
    postGroupActivitySuccess: ['data'],
    postGroupActivityFailure: ['errors'],
    postFinishActivityRequest: ['activityId', 'data'],
    postFinishActivitySuccess: ['data'],
    postFinishActivityFailure: ['errors'],
    deleteActivityRequest: ['activityId'],
    deleteActivitySuccess: ['activityId'],
    deleteActivityError: ['error'],
    activityExcelRequest: ['start_date','end_date','student_id'],
    activityExcelSuccess:['data', 'fileName'],
    activityExcelError: ['error'],
    openActivity: null,
    closeActivity: null,
    resetError: [],
  },
  {
    prefix: 'ACTIVITY_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ActivityRedux
export const ActivityTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
    success: false,
  },
  catalogue:{
    fetching: false,
    error: null,
    success: false,
  },
  delete_activity: {
    error: null,
    success: false,
    fetching: false,
  },
}, {
  get: true,
})

const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

/* ------------- Reducers ------------- */

const postActivityRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
}, d)

const postActivitySuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
    success: true,
  },
}, d)

const postActivityFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
    success: false,
  },
}, d)
const getPhotoCatalogueRequest = state => state.merge({
  catalogue: {
    fetching: true,
    error: null,
  },
}, d)

const getPhotoCatalogueSuccess = (state, { data }) => {
  let results = clone(state.get.results)
  const index =  findIndex(propEq('name', 'Photo'))(results)
  if (index > -1){
    results[index].photo_description = data
  }
  return state.merge({
    catalogue: {
      fetching: false,
      error: null,
      success: true,
    },
    get:{
      results
    }
  }, d)
}

const getPhotoCatalogueFailure = (state, { errors }) => state.merge({
  catalogue: {
    fetching: false,
    error: errors,
    success: false,
  },
}, d)
const editCheckoutRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
}, d)

const editCheckoutSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
    success: true,
  },
}, d)

const editCheckoutFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
    success: false,
  },
}, d)

const postGroupActivityRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_group_activity: {
    error: '',
    success: false,
    fetching: true,
  },
}, d)

const postGroupActivitySuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_group_activity: {
    error: '',
    success: true,
    fetching: false,
  },
  ...data,
}, d)

const postGroupActivityFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_group_activity: {
    success: false,
    error: errors[0],
    fetching: false,
  },
}, d)

const postFinishActivityRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  finish_activity: {
    error: '',
    success: false,
    fetching: true,
  },
}, d)

const postFinishActivitySuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  finish_activity: {
    error: '',
    success: true,
    fetching: false,
  },
  ...data,
}, d)

const postFinishActivityFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  finish_activity: {
    success: false,
    error: errors[0],
    fetching: false,
  },
}, d)

const deleteActivityRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  delete_activity: {
    error: null,
    success: false,
    fetching: true,
  }
})

const deleteActivitySuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  delete_activity: {
    error: null,
    success: true,
    fetching: false,
  }
})

const deleteActivityError = (state, { error }) => state.merge({
  sending: {
    fetching: false,
    error,
  },
  delete_activity: {
    error,
    success: false,
    fetching: false,
  }
})
const activityExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const activityExcelSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const activityExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const openActivity = state => (
  state.merge({ openActivity: true },d)
)

const closeActivity = state => (
  state.merge({ openActivity: false },d)
)

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.postActivityRequest]: postActivityRequest,
    [Types.postActivitySuccess]: postActivitySuccess,
    [Types.postActivityFailure]: postActivityFailure,
    [Types.getPhotoCatalogueRequest]: getPhotoCatalogueRequest,
    [Types.getPhotoCatalogueSuccess]: getPhotoCatalogueSuccess,
    [Types.getPhotoCatalogueFailure]: getPhotoCatalogueFailure,
    [Types.editCheckoutRequest]: editCheckoutRequest,
    [Types.editCheckoutSuccess]: editCheckoutSuccess,
    [Types.editCheckoutFailure]: editCheckoutFailure,
    [Types.postGroupActivityRequest]: postGroupActivityRequest,
    [Types.postGroupActivitySuccess]: postGroupActivitySuccess,
    [Types.postGroupActivityFailure]: postGroupActivityFailure,
    [Types.postFinishActivityRequest]: postFinishActivityRequest,
    [Types.postFinishActivitySuccess]: postFinishActivitySuccess,
    [Types.postFinishActivityFailure]: postFinishActivityFailure,
    [Types.deleteActivityRequest]: deleteActivityRequest,
    [Types.deleteActivitySuccess]: deleteActivitySuccess,
    [Types.deleteActivityError]: deleteActivityError,
    [Types.activityExcelRequest]: activityExcelRequest,
    [Types.activityExcelSuccess]: activityExcelSuccess,
    [Types.activityExcelError]: activityExcelError,
    [Types.openActivity]: openActivity,
    [Types.closeActivity]: closeActivity,
    [Types.resetError]: resetError,

  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ActivityRedux.js